import React from "react";

export const Header = () => {
  return <div className="container">Expense Tracker</div>;
};
